import axios from 'axios';
import { useQuery } from 'react-query';
import { fetchAllPeople } from '../../network/employees';

const { REACT_APP_API_HOST } = process.env;

export function useRoles() {
  return useQuery({
    queryKey: ['roles'],
    queryFn: async () => {
      const { data: response = [] } = await axios({
        method: 'get',
        url: `${REACT_APP_API_HOST}/v1/role`,
      });

      return response?.data;
    },
  });
}

// Shared with Home and the vacancy form so every screen caches the same shape.
export { useTeams, useOffices } from '../../hooks/useOrganisationLists';

/** Everyone in the company, for pickers (not the paginated People list). */
export function usePeople() {
  return useQuery({
    queryKey: ['people'],
    // Typed loosely, as before: callers read the response in several shapes.
    queryFn: (): Promise<any> => fetchAllPeople(),
  });
}
